/**
 * Die Projekt-Zeile auf Zuhause. (11.10.2026)
 *
 * Martin: *„Ich glaube, das Projekt kann man oben rausnehmen, weil ich das
 * kaum benutze … vielleicht als kleine Zeile darunter, unterhalb vom Header,
 * anhängen, weil das so oben wertlos ist."*
 *
 * Das aktive Projekt war ein Chip in der Kopfleiste; jetzt ist es eine leise
 * Textzeile — „Projekt · Name ›" — ganz oben im Zuhause-Blatt. Sie steht IM
 * Blatt und scrollt mit dem Inhalt weg (nicht fest), ohne Rahmen, Chip und
 * Punkt; nur das Tippziel ist 44 hoch (CSS, über Padding). Antippen öffnet das
 * Projekt wie der Chip vorher (app.ts hört auf PROJEKT_OEFFNEN).
 *
 * ⚠️ NUR Zuhause. Im Chat ist `#chat` der Behälter der Nachrichten, und gut
 *    zwei Dutzend Stellen in app.ts zählen, lesen und leeren seine Kinder
 *    (refs.chat.children, firstChild, lastElementChild). Eine Zeile darin
 *    würde als erste „Nachricht" mitgezählt.
 *
 * Besitzer von `hidden` und Text: diese Datei (`zeichneProjektZeile`). Das
 * Blatt baut die Zeile nur (`baueProjektZeile`) und bekommt dabei den Stand,
 * den es schon gibt — ein neu aufgebautes Zuhause zeigt also sofort das
 * richtige Projekt, auch wenn die Antwort des Servers früher da war.
 */
import { projektChipBeschriftung } from "./kopf-chip.js";

/** Ereignis: die Zeile wurde angetippt (app.ts öffnet das aktive Projekt). */
export const PROJEKT_OEFFNEN = "vespera:projekt-oeffnen";

const ZEILE = "data-projekt-zeile";

interface AktivesProjekt {
  name: string;
  beschreibung: string | null;
}

let aktiv: AktivesProjekt | null = null;

function zeichne(el: HTMLElement): void {
  el.hidden = !aktiv;
  if (!aktiv) return;
  const name = el.querySelector<HTMLElement>("[data-projekt-name]");
  if (name) name.textContent = aktiv.name;
  // Der volle Name steht für Maus (title) und Vorleser (aria-label), auch wenn die Zeile kürzt.
  const b = projektChipBeschriftung(aktiv.name, aktiv.beschreibung);
  el.title = b.title;
  el.setAttribute("aria-label", b.aria);
}

/** Die Zeile bauen: „Projekt · Name ›". Versteckt, solange kein Projekt aktiv ist. */
export function baueProjektZeile(): HTMLButtonElement {
  const el = document.createElement("button");
  el.type = "button";
  el.className = "projekt-zeile";
  el.setAttribute(ZEILE, "1");

  const wort = document.createElement("span");
  wort.className = "projekt-zeile-wort";
  wort.textContent = "Projekt";
  const trenner = document.createElement("span");
  trenner.className = "projekt-zeile-trenner";
  trenner.setAttribute("aria-hidden", "true");
  trenner.textContent = "·";
  const name = document.createElement("span");
  name.className = "projekt-zeile-name";
  name.setAttribute("data-projekt-name", "");
  const pfeil = document.createElement("span");
  pfeil.className = "projekt-zeile-pfeil";
  pfeil.setAttribute("aria-hidden", "true");
  pfeil.textContent = "›";
  el.append(wort, trenner, name, pfeil);

  el.addEventListener("click", () => document.dispatchEvent(new CustomEvent(PROJEKT_OEFFNEN)));
  zeichne(el);
  return el;
}

/** Das aktive Projekt setzen (oder null) — alle Zeilen im Dokument ziehen mit. */
export function zeichneProjektZeile(
  p: { name: string; description?: string | null } | null,
): void {
  aktiv = p ? { name: p.name, beschreibung: p.description ?? null } : null;
  for (const el of document.querySelectorAll<HTMLElement>(`[${ZEILE}]`)) zeichne(el);
}
